// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"229b5c3d","563":"5865fc2c","601":"4a39a788","737":"ee526854","745":"3e10675c","764":"21d217fe"}[chunkId] + ".chunk.js";
};